import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SetupPage } from "@/components/setup/SetupPage";

const searchSchema = z.object({ resume: z.string().uuid().optional() });

export const Route = createFileRoute("/concepts/new")({
  validateSearch: searchSchema,
  component: NewConceptRoute,
});

function NewConceptRoute() {
  const { resume } = Route.useSearch();
  return <SetupPage key={resume ?? "new"} resumeConceptId={resume} />;
}
